import _asyncToGenerator from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _slicedToArray from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _regeneratorRuntime from "/workdir/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import React from "react";
import { CardNumberElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { CREDIT_CARD_ADDITION_SUCCESS_ALERT, GENERIC_ERROR } from "../../../../consts";
import { useAddPaymentMethodMutation, useCreateSetupIntentMutation, useUpdatePaymentMethodMutation } from "../../../../generated/graphql.jsx";
import { AddSavedCardForm } from "../../../pure/saved-card/AddSavedCardForm/AddSavedCardForm.jsx";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var SavedCardFormContainer = function SavedCardFormContainer(_ref) {
  var paymentMethodId = _ref.paymentMethodId,
      setAlert = _ref.setAlert,
      setPaymentMethods = _ref.setPaymentMethods,
      setPaymentMethodForm = _ref.setPaymentMethodForm;
  var stripe = useStripe();
  var elements = useElements();

  var _useCreateSetupIntent = useCreateSetupIntentMutation(),
      _useCreateSetupIntent2 = _slicedToArray(_useCreateSetupIntent, 1),
      createSetupIntent = _useCreateSetupIntent2[0];

  var _useAddPaymentMethodM = useAddPaymentMethodMutation(),
      _useAddPaymentMethodM2 = _slicedToArray(_useAddPaymentMethodM, 1),
      addPaymentMethod = _useAddPaymentMethodM2[0];

  var _useUpdatePaymentMeth = useUpdatePaymentMethodMutation(),
      _useUpdatePaymentMeth2 = _slicedToArray(_useUpdatePaymentMeth, 1),
      updatePaymentMethod = _useUpdatePaymentMeth2[0];

  var confirmSetupIntent = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$createSetupInt, data, clientSecret, cardElement, _yield$stripe$confirm, error, setupIntent;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!false) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return", {
                id: ""
              });

            case 2:
              _context.next = 4;
              return createSetupIntent();

            case 4:
              _yield$createSetupInt = _context.sent;
              data = _yield$createSetupInt.data;
              clientSecret = data === null || data === void 0 ? void 0 : data.createSetupIntent.clientSecret;

              if (!(!clientSecret || !stripe || !elements)) {
                _context.next = 10;
                break;
              }

              setAlert({
                variant: "error",
                message: GENERIC_ERROR
              });
              return _context.abrupt("return");

            case 10:
              cardElement = elements.getElement(CardNumberElement);

              if (cardElement) {
                _context.next = 13;
                break;
              }

              return _context.abrupt("return");

            case 13:
              _context.next = 15;
              return stripe.confirmCardSetup(clientSecret, {
                payment_method: {
                  card: cardElement
                }
              });

            case 15:
              _yield$stripe$confirm = _context.sent;
              error = _yield$stripe$confirm.error;
              setupIntent = _yield$stripe$confirm.setupIntent;

              if (!error) {
                _context.next = 21;
                break;
              }

              setAlert({
                variant: "error",
                message: GENERIC_ERROR
              });
              return _context.abrupt("return");

            case 21:
              return _context.abrupt("return", setupIntent);

            case 22:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function confirmSetupIntent() {
      return _ref2.apply(this, arguments);
    };
  }();

  var handleSavedCardAddition = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var setupIntent;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return confirmSetupIntent();

            case 2:
              setupIntent = _context2.sent;

              if (setupIntent) {
                _context2.next = 5;
                break;
              }

              return _context2.abrupt("return");

            case 5:
              _context2.next = 7;
              return addPaymentMethod({
                variables: {
                  setupIntentId: setupIntent.id,
                  setAsDefault: false
                },
                onCompleted: function onCompleted(_ref4) {
                  var paymentMethods = _ref4.addPaymentMethod.paymentMethods;
                  setPaymentMethodForm({
                    visible: false
                  });
                  setPaymentMethods(paymentMethods);
                  setAlert({
                    variant: "success",
                    message: CREDIT_CARD_ADDITION_SUCCESS_ALERT
                  });
                },
                onError: function onError() {
                  setAlert({
                    variant: "error",
                    message: GENERIC_ERROR
                  });
                }
              });

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function handleSavedCardAddition() {
      return _ref3.apply(this, arguments);
    };
  }();

  var handleSavedCardUpdate = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
      var setupIntent;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return confirmSetupIntent();

            case 2:
              setupIntent = _context3.sent;

              if (setupIntent) {
                _context3.next = 5;
                break;
              }

              return _context3.abrupt("return");

            case 5:
              _context3.next = 7;
              return updatePaymentMethod({
                variables: {
                  setupIntentId: setupIntent.id,
                  paymentMethodId: id,
                  setAsDefault: false
                },
                onCompleted: function onCompleted(_ref6) {
                  var paymentMethods = _ref6.updatePaymentMethod.paymentMethods;
                  setPaymentMethodForm({
                    visible: false
                  });
                  setPaymentMethods(paymentMethods);
                  setAlert({
                    variant: "success",
                    message: CREDIT_CARD_ADDITION_SUCCESS_ALERT
                  });
                },
                onError: function onError() {
                  setAlert({
                    variant: "error",
                    message: GENERIC_ERROR
                  });
                }
              });

            case 7:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function handleSavedCardUpdate(_x) {
      return _ref5.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(AddSavedCardForm, {
    onSubmit: function onSubmit() {
      return paymentMethodId ? handleSavedCardUpdate(paymentMethodId) : handleSavedCardAddition();
    }
  });
};